import React from "react";
import { Button } from "react-bootstrap";

const ActivityPanel = ({ activities, formatDate, onPage }) => (
  <section className="cw-panel cw-top-activity">
    <h2>Call Activity</h2>
    {activities.error ? <p className="cw-tab-error" role="alert">{activities.error} <Button bsStyle="link" onClick={() => onPage(activities.current_page || 1)}>Retry</Button></p> : null}
    {activities.loading ? <p className="cw-muted">Loading activity…</p> : null}
    {activities.data && activities.data.length ? (
      <ol className="cw-timeline">
        {activities.data.map((activity) => (
          <li key={activity.id}>
            <strong>
              {String(activity.event_type || "activity").replace(/_/g, " ")}
            </strong>
            <span> · {activity.task && activity.task.call_type ? activity.task.call_type.name : "Call task"}{activity.task ? " #" + activity.task.id : ""}{activity.task && activity.task.source && activity.task.source.name ? " · " + activity.task.source.name : ""}</span>
            <span>{activity.actor ? " by " + activity.actor.name : ""}</span>
            <small>{formatDate(activity.occurred_at, true)}</small>
          </li>
        ))}
      </ol>
    ) : !activities.loading && !activities.error ? (
      <p className="cw-muted">No activity recorded.</p>
    ) : null}
    {activities.total > 0 ? <div className="cw-pagination" aria-label="Activity pages">
      <span>{activities.total} activities</span>
      <div>
        <Button type="button" disabled={activities.current_page <= 1 || activities.loading} onClick={() => onPage(activities.current_page - 1)}>Previous</Button>
        <span>Page {activities.current_page} of {activities.last_page}</span>
        <Button type="button" disabled={activities.current_page >= activities.last_page || activities.loading} onClick={() => onPage(activities.current_page + 1)}>Next</Button>
      </div>
    </div> : null}
  </section>
);

export default ActivityPanel;
